var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("h2", [_vm._v("交接班")]),
      _c(
        "div",
        { staticClass: "search-term block" },
        [
          _c(
            "el-form",
            { attrs: { inline: true } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "交班油站" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "请选择"
                      },
                      model: {
                        value: _vm.selectedStationId,
                        callback: function($$v) {
                          _vm.selectedStationId = $$v
                        },
                        expression: "selectedStationId"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "请选择站点", value: 0, disabled: "" }
                      }),
                      _vm._l(_vm.showAsyncStations, function(item) {
                        return _c("el-option", {
                          key: item.ID,
                          attrs: { label: item.statTag, value: item.ID }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-date-picker", {
                    attrs: {
                      editable: false,
                      type: "date",
                      "value-format": "timestamp",
                      "picker-options": _vm.pickerOptionsLimit
                    },
                    model: {
                      value: _vm.datePickerValue,
                      callback: function($$v) {
                        _vm.datePickerValue = $$v
                      },
                      expression: "datePickerValue"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.loadData } },
                    [_vm._v("查询")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.shiftCounters && _vm.shiftCounters.length > 0
        ? _c(
            "div",
            { staticClass: "chart-wrapper" },
            [
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("站内班报表")
              ]),
              _vm._l(_vm.shiftCounters, function(item, i) {
                return _c(
                  "el-row",
                  { key: i, attrs: { gutter: 20 } },
                  [
                    _c("el-col", { attrs: { xs: 24, sm: 24, lg: 24 } }, [
                      _c(
                        "div",
                        { staticClass: "metric-wrapper" },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 80 } },
                            [
                              _c("el-col", { attrs: { span: 4 } }, [
                                _c("div", { staticClass: "metric-item" }, [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "metric-item-title" },
                                        [_vm._v("班次编制：")]
                                      ),
                                      item.shiftStatus === 1
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "metric-item-number"
                                            },
                                            [_vm._v(_vm._s(item.shiftName))]
                                          )
                                        : _c("el-tooltip", [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "metric-item-number",
                                                staticStyle: {
                                                  color: "#04bb03"
                                                }
                                              },
                                              [_vm._v(_vm._s(item.shiftName))]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content"
                                              },
                                              [_vm._v("当前班次")]
                                            )
                                          ])
                                    ],
                                    1
                                  )
                                ])
                              ]),
                              _c("el-col", { attrs: { span: 5 } }, [
                                _c("div", { staticClass: "metric-item" }, [
                                  _c("div", [
                                    _c(
                                      "span",
                                      { staticClass: "metric-item-title" },
                                      [_vm._v("交班账号：")]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "metric-item-number" },
                                      [_vm._v(_vm._s(item.sysUserName))]
                                    )
                                  ])
                                ])
                              ]),
                              _c("el-col", { attrs: { span: 10 } }, [
                                _c("div", { staticClass: "metric-item" }, [
                                  _c("div", [
                                    _c(
                                      "span",
                                      { staticClass: "metric-item-title" },
                                      [_vm._v("班次时间：")]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "metric-item-number" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.normalDateTime(item.startDate)
                                          ) +
                                            " ~ " +
                                            _vm._s(
                                              item.shiftStatus === 1
                                                ? _vm.normalDateTime(
                                                    item.endDate
                                                  )
                                                : ""
                                            )
                                        )
                                      ]
                                    )
                                  ])
                                ])
                              ]),
                              _c("el-col", { attrs: { span: 5 } }, [
                                _c("div", { staticClass: "metric-item" }, [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "metric-item-title" },
                                        [_vm._v("操作：")]
                                      ),
                                      item.shiftStatus === 1
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "warning",
                                                size: "mini"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.gotoReport(
                                                    item,
                                                    "shiftDiff",
                                                    _vm.datePickerValue
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("查看")]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              }),
              _c("br"),
              _vm.userInfo.authorityId !== "9997"
                ? _c(
                    "div",
                    [
                      _c(
                        "el-divider",
                        { attrs: { "content-position": "left" } },
                        [_vm._v("站内日报表")]
                      ),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c("el-col", { attrs: { xs: 24, sm: 24, lg: 24 } }, [
                            _c(
                              "div",
                              { staticClass: "metric-wrapper" },
                              [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 80 } },
                                  [
                                    _c("el-col", { attrs: { span: 4 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "metric-item" },
                                        [
                                          _c(
                                            "div",
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "metric-item-title"
                                                },
                                                [_vm._v("日报编号：")]
                                              ),
                                              _vm.dailyShift.shiftStatus === 1
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "metric-item-number"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.dailyShift
                                                            .dailyNo +
                                                            _vm.selectedStationId +
                                                            _vm.dailyShift
                                                              .reportDate
                                                        )
                                                      )
                                                    ]
                                                  )
                                                : _c("el-tooltip", [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "metric-item-number",
                                                        staticStyle: {
                                                          color: "#04bb03"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.dailyShift
                                                              .dailyNo +
                                                              _vm.selectedStationId +
                                                              _vm.dailyShift
                                                                .reportDate
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        attrs: {
                                                          slot: "content"
                                                        },
                                                        slot: "content"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "当天班次交接完后可查看日报"
                                                        )
                                                      ]
                                                    )
                                                  ])
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ]),
                                    _c("el-col", { attrs: { span: 5 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "metric-item" },
                                        [
                                          _c("div", [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "metric-item-title"
                                              },
                                              [_vm._v("站点：")]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "metric-item-number"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getStationName(
                                                      _vm.selectedStationId
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ])
                                        ]
                                      )
                                    ]),
                                    _c("el-col", { attrs: { span: 10 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "metric-item" },
                                        [
                                          _c("div", [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "metric-item-title"
                                              },
                                              [_vm._v("日报时间：")]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "metric-item-number"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.dailyShift.startTime
                                                  ) +
                                                    " ~ " +
                                                    _vm._s(
                                                      _vm.dailyShift.endTime
                                                    )
                                                )
                                              ]
                                            )
                                          ])
                                        ]
                                      )
                                    ]),
                                    _c("el-col", { attrs: { span: 5 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "metric-item" },
                                        [
                                          _c(
                                            "div",
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "metric-item-title"
                                                },
                                                [_vm._v("操作：")]
                                              ),
                                              _vm.dailyShift.shiftStatus === 1
                                                ? _c(
                                                    "el-button",
                                                    {
                                                      attrs: {
                                                        type: "danger",
                                                        size: "mini"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.gotoReport(
                                                            _vm.dailyCashierDataRow,
                                                            "dailyDiff",
                                                            null
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("查看")]
                                                  )
                                                : _vm._e(),
                                              _vm.dailyShift.shiftStatus === 1
                                                ? _c(
                                                    "el-button",
                                                    {
                                                      attrs: {
                                                        type: "info",
                                                        size: "mini"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.showInsertDailyPayData(
                                                            _vm.dailyShift
                                                              .shiftStatus,
                                                            _vm.dailyShift
                                                              .dailyNo +
                                                              _vm.selectedStationId +
                                                              _vm.dailyShift
                                                                .reportDate,
                                                            _vm.selectedStationId
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("补录")]
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      ),
                      _c("br"),
                      _vm.dailyShift.shiftStatus === 1
                        ? _c(
                            "el-divider",
                            { attrs: { "content-position": "left" } },
                            [_vm._v("平台日报表")]
                          )
                        : _vm._e(),
                      _vm.dailyShift.shiftStatus === 1
                        ? _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { xs: 24, sm: 24, lg: 24 } },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "metric-wrapper" },
                                    [
                                      _c(
                                        "el-row",
                                        { attrs: { gutter: 80 } },
                                        [
                                          _c("el-col", { attrs: { span: 6 } }, [
                                            _c(
                                              "div",
                                              { staticClass: "metric-item" },
                                              [
                                                _vm.dailyCashierDataRow
                                                  .dailyPlatformData.length > 0
                                                  ? _c(
                                                      "div",
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "metric-item-title",
                                                            staticStyle: {
                                                              color: "#04bb03"
                                                            }
                                                          },
                                                          [_vm._v("已录入")]
                                                        ),
                                                        _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              type: "primary",
                                                              size: "mini"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.excelReadDataDialog = true
                                                                _vm.excelReadGridData =
                                                                  _vm.dailyCashierDataRow.dailyPlatformData
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "点击查看平台数据"
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _c(
                                                      "div",
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "metric-item-title",
                                                            staticStyle: {
                                                              color: "#ff4d51"
                                                            }
                                                          },
                                                          [_vm._v("待录入")]
                                                        ),
                                                        _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              type: "warning",
                                                              size: "mini"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.excelReadDataDialog = true
                                                                _vm.excelReadGridData = []
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "点击上传平台数据"
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                              ]
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        : _c(
            "div",
            { staticClass: "chart-wrapper" },
            [_c("el-row", [_vm._v("暂无数据")])],
            1
          ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "收银录入",
            top: "2rem",
            visible: _vm.needShiftCashierDataDialog,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.needShiftCashierDataDialog = $event
            }
          }
        },
        [
          _c("h3", { staticStyle: { margin: "1rem", "font-size": "1.4rem" } }, [
            _vm._v(_vm._s(_vm.shiftCashierData.shiftName))
          ]),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.normalDateTime(_vm.shiftCashierData.startDate) +
                  " ~ " +
                  _vm.normalDateTime(_vm.shiftCashierData.endDate)
              )
            )
          ]),
          _c("br"),
          _c(
            "el-form",
            { ref: "dataForm", attrs: { "label-position": "left" } },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.shiftCashierData.shiftPaywayList.filter(function(
                      data
                    ) {
                      return (
                        (data.payWay > 2000 &&
                          data.payWay < 3000 &&
                          data.payWay !== 2006) ||
                        data.payWay === 1001 ||
                        data.payWay === 1005 ||
                        data.payWay === 1015 ||
                        data.payWay === 1025 ||
                        data.payWay === 1045 ||
                        data.payWay === 1006 ||
                        data.payWay === 1008 ||
                        data.payWay === 1009
                      )
                    }),
                    border: "",
                    stripe: ""
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "收款方式",
                      prop: "payWayName",
                      align: "center"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "营业额",
                      prop: "checkPayablesAmount",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("el-input-number", {
                              attrs: {
                                placeholder: "营业额",
                                "controls-position": "right",
                                precision: 2,
                                clearable: ""
                              },
                              model: {
                                value: scope.row.checkPayablesAmount,
                                callback: function($$v) {
                                  _vm.$set(
                                    scope.row,
                                    "checkPayablesAmount",
                                    $$v
                                  )
                                },
                                expression: "scope.row.checkPayablesAmount"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.needShiftCashierDataDialog = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-popconfirm",
                {
                  attrs: {
                    title: "请核对已填写的数据，确认无误点继续即可提交",
                    "confirm-button-text": "继续",
                    "cancel-button-text": "再看看"
                  },
                  on: { confirm: _vm.doShiftCashierData }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { slot: "reference", type: "primary" },
                      slot: "reference"
                    },
                    [_vm._v("确认")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "主管核对",
            top: "2rem",
            visible: _vm.needDailyCashierDataDialog,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.needDailyCashierDataDialog = $event
            }
          }
        },
        [
          _c("h3", { staticStyle: { margin: "1rem", "font-size": "1.4rem" } }, [
            _vm._v(_vm._s(_vm.dailyCashierData.dailyReportName))
          ]),
          _c("p", [
            _vm._v(
              _vm._s(_vm.dailyShift.startTime + " ~ " + _vm.dailyShift.endTime)
            )
          ]),
          _c("br"),
          _c(
            "el-form",
            { ref: "dataForm", attrs: { "label-position": "left" } },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.dailyCashierData.dailyPayWayData.filter(function(
                      data
                    ) {
                      return (
                        (data.payWay > 2000 &&
                          data.payWay < 3000 &&
                          data.payWay !== 2006) ||
                        data.payWay === 1001 ||
                        data.payWay === 1005 ||
                        data.payWay === 1015 ||
                        data.payWay === 1025 ||
                        data.payWay === 1045 ||
                        data.payWay === 1006 ||
                        data.payWay === 1008 ||
                        data.payWay === 1009
                      )
                    }),
                    border: "",
                    stripe: ""
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "收款方式",
                      prop: "payWayName",
                      align: "center"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "营业额",
                      prop: "checkPayablesAmount",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.payWay < 2000 && scope.row.payWay !== 1008
                              ? _c("div", [_vm._v(" -- ")])
                              : _c(
                                  "div",
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        placeholder: "营业额",
                                        "controls-position": "right",
                                        disabled:
                                          ((scope.row.payWay > 2000 &&
                                            scope.row.payWay < 3000) ||
                                            scope.row.payWay === 1008) &&
                                          _vm.userInfo.authorityId !== "888",
                                        precision: 2,
                                        clearable: ""
                                      },
                                      model: {
                                        value: scope.row.checkPayablesAmount,
                                        callback: function($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "checkPayablesAmount",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "scope.row.checkPayablesAmount"
                                      }
                                    })
                                  ],
                                  1
                                )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "实收",
                      prop: "checkPaymentsAmount",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.payWay === 1001
                              ? _c(
                                  "div",
                                  [
                                    _vm._v(" A班： "),
                                    _c("el-input-number", {
                                      staticStyle: { height: "47px" },
                                      attrs: {
                                        placeholder: "A班实收",
                                        "controls-position": "right",
                                        precision: 2,
                                        min: 0,
                                        clearable: ""
                                      },
                                      model: {
                                        value: _vm.dailyCheckPaymentsAmount[0],
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.dailyCheckPaymentsAmount,
                                            0,
                                            $$v
                                          )
                                        },
                                        expression:
                                          "dailyCheckPaymentsAmount[0]"
                                      }
                                    }),
                                    _c("br"),
                                    _vm._v(" B班： "),
                                    _c("el-input-number", {
                                      staticStyle: { height: "47px" },
                                      attrs: {
                                        placeholder: "B班实收",
                                        "controls-position": "right",
                                        precision: 2,
                                        min: 0,
                                        clearable: ""
                                      },
                                      model: {
                                        value: _vm.dailyCheckPaymentsAmount[1],
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.dailyCheckPaymentsAmount,
                                            1,
                                            $$v
                                          )
                                        },
                                        expression:
                                          "dailyCheckPaymentsAmount[1]"
                                      }
                                    }),
                                    _c("br"),
                                    _vm._v(" C班： "),
                                    _c("el-input-number", {
                                      staticStyle: { height: "47px" },
                                      attrs: {
                                        placeholder: "C班实收",
                                        "controls-position": "right",
                                        precision: 2,
                                        min: 0,
                                        clearable: ""
                                      },
                                      model: {
                                        value: _vm.dailyCheckPaymentsAmount[2],
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.dailyCheckPaymentsAmount,
                                            2,
                                            $$v
                                          )
                                        },
                                        expression:
                                          "dailyCheckPaymentsAmount[2]"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  [
                                    _c("el-input-number", {
                                      staticStyle: { height: "47px" },
                                      attrs: {
                                        placeholder: "实收",
                                        "controls-position": "right",
                                        disabled:
                                          ((scope.row.payWay > 2000 &&
                                            scope.row.payWay < 3000) ||
                                            scope.row.payWay === 1008) &&
                                          _vm.userInfo.authorityId !== "888",
                                        precision: 2,
                                        clearable: ""
                                      },
                                      model: {
                                        value: scope.row.checkPaymentsAmount,
                                        callback: function($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "checkPaymentsAmount",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "scope.row.checkPaymentsAmount"
                                      }
                                    })
                                  ],
                                  1
                                )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.needDailyCashierDataDialog = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-popconfirm",
                {
                  attrs: {
                    title: "请核对已填写的数据，确认无误点继续即可提交",
                    "confirm-button-text": "继续",
                    "cancel-button-text": "再看看"
                  },
                  on: { confirm: _vm.doDailyCashierData }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { slot: "reference", type: "primary" },
                      slot: "reference"
                    },
                    [_vm._v("确认")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "快捷交班",
            top: "2rem",
            visible: _vm.showShiftDiffDialog,
            width: "86%",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.showShiftDiffDialog = $event
            }
          }
        },
        [
          _c("h3", { staticStyle: { margin: "1rem", "font-size": "1.4rem" } }, [
            _vm._v(_vm._s(_vm.showShiftDiffData.shiftName))
          ]),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.normalDateTime(_vm.showShiftDiffData.startDate) +
                  " ~ " +
                  _vm.normalDateTime(_vm.showShiftDiffData.endDate)
              )
            )
          ]),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.showShiftDiffData.shiftPaywayList.filter(function(
                  data
                ) {
                  return (
                    (data.payWay > 2000 &&
                      data.payWay < 3000 &&
                      data.payWay !== 2006) ||
                    data.payWay === 1001 ||
                    data.payWay === 1005 ||
                    data.payWay === 1015 ||
                    data.payWay === 1025 ||
                    data.payWay === 1045 ||
                    data.payWay === 1006 ||
                    data.payWay === 1008 ||
                    data.payWay === 1009
                  )
                }),
                border: ""
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "收款方式",
                  prop: "payWayName",
                  align: "center"
                }
              }),
              _c(
                "el-table-column",
                { attrs: { label: "营业额", align: "center" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "系统统计",
                      prop: "shiftReceivablesAmount",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.payWay === 1001
                              ? _c("p", [
                                  _vm._v(
                                    _vm._s(scope.row.shiftPaymentsAmount) +
                                      "（应） " +
                                      _vm._s(scope.row.shiftReceivablesAmount) +
                                      "（实）"
                                  )
                                ])
                              : _c("p", [
                                  _vm._v(
                                    _vm._s(scope.row.shiftReceivablesAmount)
                                  )
                                ])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "收银录入",
                      prop: "checkPayablesAmount",
                      align: "center"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "差异比对", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.payWay === 1001
                              ? _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      size: "mini",
                                      type:
                                        scope.row.checkPayablesAmount >
                                        scope.row.shiftPaymentsAmount
                                          ? "success"
                                          : scope.row.checkPayablesAmount <
                                            scope.row.shiftPaymentsAmount
                                          ? "danger"
                                          : "info"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          scope.row.checkPayablesAmount !==
                                            scope.row.shiftPaymentsAmount
                                            ? _vm.npMinus(
                                                scope.row.checkPayablesAmount,
                                                scope.row.shiftPaymentsAmount
                                              )
                                            : "-"
                                        )
                                    )
                                  ]
                                )
                              : _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      size: "mini",
                                      type:
                                        scope.row.checkPayablesAmount >
                                        scope.row.shiftReceivablesAmount
                                          ? "success"
                                          : scope.row.checkPayablesAmount <
                                            scope.row.shiftReceivablesAmount
                                          ? "danger"
                                          : "info"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          scope.row.checkPayablesAmount !==
                                            scope.row.shiftReceivablesAmount
                                            ? _vm.npMinus(
                                                scope.row.checkPayablesAmount,
                                                scope.row.shiftReceivablesAmount
                                              )
                                            : "-"
                                        )
                                    )
                                  ]
                                )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("div", [
            _c(
              "h3",
              { staticStyle: { margin: "1rem", "font-size": "1.4rem" } },
              [_vm._v("便利店情况")]
            ),
            _c("p", { staticStyle: { "padding-left": "1rem" } }, [
              _vm._v("当班销售额：" + _vm._s(_vm.shiftDiff.shopAmount))
            ])
          ]),
          _c("h3", { staticStyle: { margin: "1rem", "font-size": "1.4rem" } }, [
            _vm._v("差异比对")
          ]),
          _vm.showShiftDiffDialog && _vm.shiftDiff.chargeBackAmount < 0
            ? _c("el-alert", {
                attrs: {
                  title:
                    "当班充值数据中已对冲退卡/回款金额：" +
                    _vm.absNumber(_vm.shiftDiff.chargeBackAmount),
                  type: "success",
                  "show-icon": "",
                  closable: false
                }
              })
            : _vm._e(),
          _vm.showShiftDiffDialog && _vm.shiftDiff.lossAmount > 0
            ? _c("el-alert", {
                attrs: {
                  title:
                    "当班补卡应收金额：" +
                    _vm.absNumber(_vm.shiftDiff.lossAmount),
                  type: "error",
                  "show-icon": "",
                  closable: false
                }
              })
            : _vm._e(),
          _vm.showShiftDiffDialog && _vm.shiftDiff.preStationAmount > 0
            ? _c("el-alert", {
                attrs: {
                  title: "油品预收款数据",
                  description:
                    "油机金额：" +
                    _vm.shiftDiff.preStationSaleAmount +
                    "　升数：" +
                    _vm.shiftDiff.preStationOilMass +
                    "　优惠：" +
                    _vm.shiftDiff.preStationDiscount +
                    "　实收：" +
                    _vm.shiftDiff.preStationAmount,
                  type: "warning",
                  "show-icon": "",
                  closable: false
                }
              })
            : _vm._e(),
          _c(
            "h2",
            { staticStyle: { "padding-left": "1rem" } },
            [
              _vm._v("当班差异："),
              _c(
                "el-tag",
                {
                  staticStyle: { "font-size": "1.5rem" },
                  attrs: {
                    type:
                      _vm.amountFormat(
                        _vm.npMinus(
                          _vm.npPlus(
                            _vm.shiftDiff.cashAmount,
                            _vm.shiftDiff.posAmount,
                            _vm.shiftDiff.onlineAmount,
                            _vm.shiftDiff.svcAmount,
                            _vm.shiftDiff.walletAmount,
                            _vm.shiftDiff.creditAmount,
                            _vm.shiftDiff.accountAmount,
                            _vm.shiftDiff.platAmount,
                            _vm.shiftDiff.othersAmount,
                            _vm.shiftDiff.specialAmount,
                            _vm.shiftDiff.sellerDiscount,
                            _vm.shiftDiff.platDiscount
                          ),
                          _vm.npPlus(
                            _vm.shiftDiff.stationAmount,
                            _vm.shiftDiff.shopAmount,
                            _vm.shiftDiff.chargeAmount,
                            _vm.shiftDiff.lossAmount,
                            _vm.shiftDiff.loadometerAmount,
                            _vm.shiftDiff.creditAmount,
                            _vm.shiftDiff.accountAmount
                          )
                        ),
                        2
                      ) > 0
                        ? "success"
                        : "danger"
                  }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.amountFormat(
                        _vm.npMinus(
                          _vm.npPlus(
                            _vm.shiftDiff.cashAmount,
                            _vm.shiftDiff.posAmount,
                            _vm.shiftDiff.onlineAmount,
                            _vm.shiftDiff.svcAmount,
                            _vm.shiftDiff.walletAmount,
                            _vm.shiftDiff.creditAmount,
                            _vm.shiftDiff.accountAmount,
                            _vm.shiftDiff.platAmount,
                            _vm.shiftDiff.othersAmount,
                            _vm.shiftDiff.specialAmount,
                            _vm.shiftDiff.sellerDiscount,
                            _vm.shiftDiff.platDiscount
                          ),
                          _vm.npPlus(
                            _vm.shiftDiff.stationAmount,
                            _vm.shiftDiff.shopAmount,
                            _vm.shiftDiff.chargeAmount,
                            _vm.shiftDiff.lossAmount,
                            _vm.shiftDiff.loadometerAmount,
                            _vm.shiftDiff.creditAmount,
                            _vm.shiftDiff.accountAmount
                          )
                        ),
                        2
                      )
                    )
                  )
                ]
              )
            ],
            1
          ),
          _vm.userInfo.authorityId === "888" ||
          _vm.userInfo.authorityId === "9990" ||
          _vm.userInfo.authorityId === "30003" ||
          _vm.userInfo.authorityId === "9994"
            ? _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: [_vm.shiftDiff], border: "", stripe: "" }
                },
                [
                  _c(
                    "el-table-column",
                    { attrs: { label: "销售", align: "center" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "油机金额",
                          width: "110px",
                          prop: "stationAmount",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "便利店",
                          prop: "shopAmount",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "充值数据",
                          width: "110px",
                          prop: "chargeAmount",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "补卡",
                          prop: "lossAmount",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "地磅计费",
                          prop: "loadometerAmount",
                          align: "center"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-table-column",
                    { attrs: { label: "优惠", align: "center" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "平台优惠",
                          prop: "platDiscount",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "油站优惠",
                          prop: "sellerDiscount",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "特殊结算",
                          prop: "specialAmount",
                          align: "center"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-table-column",
                    { attrs: { label: "支付", align: "center" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "现金",
                          prop: "cashAmount",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "POS机",
                          width: "100px",
                          prop: "posAmount",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "在线支付",
                          width: "110px",
                          prop: "onlineAmount",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "储值卡",
                          width: "100px",
                          prop: "svcAmount",
                          align: "center"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.amountFormat(
                                          _vm.np3Minus(
                                            scope.row.svcAmount,
                                            scope.row.creditAmount,
                                            scope.row.accountAmount
                                          ),
                                          2
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1193001739
                        )
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "授权卡",
                          prop: "creditAmount",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "记账卡",
                          prop: "accountAmount",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "电子钱包",
                          prop: "walletAmount",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "平台",
                          width: "100px",
                          prop: "platAmount",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "其他",
                          prop: "othersAmount",
                          align: "center"
                        }
                      })
                    ],
                    1
                  ),
                  _c("el-table-column", {
                    attrs: {
                      label: "差异",
                      prop: "diffAmount",
                      align: "center"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.amountFormat(
                                      _vm.npMinus(
                                        _vm.npPlus(
                                          scope.row.cashAmount,
                                          scope.row.posAmount,
                                          scope.row.onlineAmount,
                                          scope.row.svcAmount,
                                          scope.row.walletAmount,
                                          scope.row.creditAmount,
                                          scope.row.accountAmount,
                                          scope.row.platAmount,
                                          scope.row.othersAmount,
                                          scope.row.specialAmount,
                                          scope.row.sellerDiscount,
                                          scope.row.platDiscount
                                        ),
                                        _vm.npPlus(
                                          scope.row.stationAmount,
                                          scope.row.shopAmount,
                                          scope.row.chargeAmount,
                                          scope.row.lossAmount,
                                          scope.row.loadometerAmount,
                                          scope.row.creditAmount,
                                          scope.row.accountAmount
                                        )
                                      ),
                                      2
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2826185115
                    )
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "1rem" }, attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-input", {
                    staticClass: "text-color",
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 2, maxRows: 4 },
                      placeholder: "请输入差异说明",
                      readonly: _vm.shiftDiff.shiftInfoStatus === 2
                    },
                    model: {
                      value: _vm.shiftDiff.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.shiftDiff, "remark", $$v)
                      },
                      expression: "shiftDiff.remark"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "medium",
                        disabled: _vm.shiftDiff.shiftInfoStatus === 2
                      },
                      on: {
                        click: function($event) {
                          return _vm.submitShiftRemark(
                            _vm.shiftDiff.shiftNo,
                            _vm.shiftDiff.stationId,
                            _vm.shiftDiff.shiftInfoStatus,
                            _vm.shiftDiff.remark
                          )
                        }
                      }
                    },
                    [_vm._v("提交")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "快捷日报",
            top: "2rem",
            visible: _vm.showDailyDiffDialog,
            width: "86%",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.showDailyDiffDialog = $event
            }
          }
        },
        [
          _c("h3", { staticStyle: { margin: "1rem", "font-size": "1.4rem" } }, [
            _vm._v(_vm._s(_vm.showDailyDiffData.dailyReportName))
          ]),
          _c("p", [
            _vm._v(
              _vm._s(_vm.dailyShift.startTime + " ~ " + _vm.dailyShift.endTime)
            )
          ]),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data:
                  _vm.showDailyDiffData.length === 0 ||
                  _vm.showDailyDiffData.dailyPayWayData.length === 0
                    ? []
                    : _vm.showDailyDiffData.dailyPayWayData.filter(function(
                        data
                      ) {
                        return (
                          (data.payWay > 2000 &&
                            data.payWay < 3000 &&
                            data.payWay !== 2006) ||
                          data.payWay === 1001 ||
                          data.payWay === 1005 ||
                          data.payWay === 1015 ||
                          data.payWay === 1025 ||
                          data.payWay === 1045 ||
                          data.payWay === 1006 ||
                          data.payWay === 1008 ||
                          data.payWay === 1009
                        )
                      }),
                border: ""
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "收款方式",
                  prop: "payWayName",
                  align: "center"
                }
              }),
              _c(
                "el-table-column",
                { attrs: { label: "营业额", align: "center" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "系统统计",
                      prop: "receivablesAmount",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.payWay === 1001
                              ? _c("p", [
                                  _vm._v(
                                    _vm._s(scope.row.paymentsAmount) +
                                      "（应） " +
                                      _vm._s(scope.row.receivablesAmount) +
                                      "（实）"
                                  )
                                ])
                              : _c("p", [
                                  _vm._v(_vm._s(scope.row.receivablesAmount))
                                ])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "当天营业额",
                      prop: "checkPayablesAmount",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.payWay === 1001
                              ? _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      {
                                        staticStyle: { "text-align": "left" },
                                        attrs: { span: "16" }
                                      },
                                      [
                                        _vm._v(" 收银录入："),
                                        _c("br"),
                                        _vm._v(
                                          " A班：" +
                                            _vm._s(
                                              _vm.dailyShiftPayablesAmount
                                                .length > 0 &&
                                                _vm.dailyShiftPayablesAmount[0]
                                                ? _vm
                                                    .dailyShiftPayablesAmount[0]
                                                : 0
                                            )
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          " B班：" +
                                            _vm._s(
                                              _vm.dailyShiftPayablesAmount
                                                .length > 1 &&
                                                _vm.dailyShiftPayablesAmount[1]
                                                ? _vm
                                                    .dailyShiftPayablesAmount[1]
                                                : 0
                                            )
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          " C班：" +
                                            _vm._s(
                                              _vm.dailyShiftPayablesAmount
                                                .length > 2 &&
                                                _vm.dailyShiftPayablesAmount[2]
                                                ? _vm
                                                    .dailyShiftPayablesAmount[2]
                                                : 0
                                            ) +
                                            " "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-col",
                                      {
                                        staticStyle: { "text-align": "left" },
                                        attrs: { span: "8" }
                                      },
                                      [
                                        _vm._v(" 现金合计："),
                                        _c("br"),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.npPlusArr(
                                                _vm.dailyShiftPayablesAmount
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _c("el-row", [
                                  _vm._v(
                                    " " +
                                      _vm._s(scope.row.checkPayablesAmount) +
                                      " "
                                  )
                                ])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "当天实收",
                      prop: "checkPaymentsAmount",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.payWay === 1001
                              ? _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      {
                                        staticStyle: { "text-align": "left" },
                                        attrs: { span: "16" }
                                      },
                                      [
                                        _vm._v(" 主管录入："),
                                        _c("br"),
                                        _vm._v(
                                          " A班：" +
                                            _vm._s(
                                              _vm.dailyCheckPaymentsAmount
                                                .length > 0 &&
                                                _vm.dailyCheckPaymentsAmount[0]
                                                ? _vm
                                                    .dailyCheckPaymentsAmount[0]
                                                : 0
                                            )
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          " B班：" +
                                            _vm._s(
                                              _vm.dailyCheckPaymentsAmount
                                                .length > 1 &&
                                                _vm.dailyCheckPaymentsAmount[1]
                                                ? _vm
                                                    .dailyCheckPaymentsAmount[1]
                                                : 0
                                            )
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          " C班：" +
                                            _vm._s(
                                              _vm.dailyCheckPaymentsAmount
                                                .length > 2 &&
                                                _vm.dailyCheckPaymentsAmount[2]
                                                ? _vm
                                                    .dailyCheckPaymentsAmount[2]
                                                : 0
                                            ) +
                                            " "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-col",
                                      {
                                        staticStyle: { "text-align": "left" },
                                        attrs: { span: "8" }
                                      },
                                      [
                                        _vm._v(" 现金合计："),
                                        _c("br"),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.npPlusArr(
                                                _vm.dailyCheckPaymentsAmount
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _c("el-row", [
                                  _vm._v(
                                    " " +
                                      _vm._s(scope.row.checkPaymentsAmount) +
                                      " "
                                  )
                                ])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "差异比对", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.payWay === 1001
                              ? _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      {
                                        staticStyle: { "text-align": "left" },
                                        attrs: { span: "16" }
                                      },
                                      [
                                        _vm._v(" 各班次："),
                                        _c("br"),
                                        _vm._v(" A班："),
                                        _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              size: "mini",
                                              type:
                                                _vm
                                                  .dailyCheckPaymentsAmount[0] >
                                                _vm.dailyShiftPayablesAmount[0]
                                                  ? "success"
                                                  : _vm
                                                      .dailyCheckPaymentsAmount[0] <
                                                    _vm
                                                      .dailyShiftPayablesAmount[0]
                                                  ? "danger"
                                                  : "info"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm
                                                    .dailyCheckPaymentsAmount[0] !==
                                                    _vm
                                                      .dailyShiftPayablesAmount[0]
                                                    ? _vm.npMinus(
                                                        _vm
                                                          .dailyCheckPaymentsAmount[0],
                                                        _vm
                                                          .dailyShiftPayablesAmount[0]
                                                      )
                                                    : "-"
                                                )
                                            )
                                          ]
                                        ),
                                        _c("br"),
                                        _vm._v(" B班："),
                                        _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              size: "mini",
                                              type:
                                                _vm
                                                  .dailyCheckPaymentsAmount[1] >
                                                _vm.dailyShiftPayablesAmount[1]
                                                  ? "success"
                                                  : _vm
                                                      .dailyCheckPaymentsAmount[1] <
                                                    _vm
                                                      .dailyShiftPayablesAmount[1]
                                                  ? "danger"
                                                  : "info"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm
                                                    .dailyCheckPaymentsAmount[1] !==
                                                    _vm
                                                      .dailyShiftPayablesAmount[1]
                                                    ? _vm.npMinus(
                                                        _vm
                                                          .dailyCheckPaymentsAmount[1],
                                                        _vm
                                                          .dailyShiftPayablesAmount[1]
                                                      )
                                                    : "-"
                                                )
                                            )
                                          ]
                                        ),
                                        _c("br"),
                                        _vm._v(" C班："),
                                        _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              size: "mini",
                                              type:
                                                _vm
                                                  .dailyCheckPaymentsAmount[2] >
                                                _vm.dailyShiftPayablesAmount[2]
                                                  ? "success"
                                                  : _vm
                                                      .dailyCheckPaymentsAmount[2] <
                                                    _vm
                                                      .dailyShiftPayablesAmount[2]
                                                  ? "danger"
                                                  : "info"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm
                                                    .dailyCheckPaymentsAmount[2] !==
                                                    _vm
                                                      .dailyShiftPayablesAmount[2]
                                                    ? _vm.npMinus(
                                                        _vm
                                                          .dailyCheckPaymentsAmount[2],
                                                        _vm
                                                          .dailyShiftPayablesAmount[2]
                                                      )
                                                    : "-"
                                                )
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      {
                                        staticStyle: { "text-align": "left" },
                                        attrs: { span: "8" }
                                      },
                                      [
                                        _vm._v(" 现金差异："),
                                        _c("br"),
                                        _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              size: "mini",
                                              type:
                                                _vm.dailyCheckPaymentsAmountSum >
                                                scope.row.paymentsAmount
                                                  ? "success"
                                                  : _vm.dailyCheckPaymentsAmountSum <
                                                    scope.row.paymentsAmount
                                                  ? "danger"
                                                  : "info"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.dailyCheckPaymentsAmountSum !==
                                                    scope.row.paymentsAmount
                                                    ? _vm.npMinus(
                                                        _vm.dailyCheckPaymentsAmountSum,
                                                        scope.row.paymentsAmount
                                                      )
                                                    : "-"
                                                )
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type:
                                            scope.row.checkPayablesAmount >
                                            scope.row.receivablesAmount
                                              ? "success"
                                              : scope.row.checkPayablesAmount <
                                                scope.row.receivablesAmount
                                              ? "danger"
                                              : "info"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              scope.row.checkPayablesAmount !==
                                                scope.row.receivablesAmount
                                                ? _vm.npMinus(
                                                    scope.row
                                                      .checkPayablesAmount,
                                                    scope.row.receivablesAmount
                                                  )
                                                : "-"
                                            )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "80px", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "warning",
                                  size: "mini",
                                  disabled: !(
                                    _vm.userInfo.authorityId === "888" ||
                                    _vm.userInfo.authorityId === "9990" ||
                                    _vm.userInfo.authorityId === "30003" ||
                                    _vm.userInfo.authorityId === "9994" ||
                                    (scope.row.payWay !== 1001 &&
                                      scope.row.payWay < 2000 &&
                                      scope.row.payWay !== 1008)
                                  )
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.showModifyDailyPayData(
                                      _vm.dailyDiff.dailyNo,
                                      _vm.dailyDiff.stationId,
                                      scope.row
                                    )
                                  }
                                }
                              },
                              [_vm._v("修改")]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("div", [
            _c(
              "h3",
              { staticStyle: { margin: "1rem", "font-size": "1.4rem" } },
              [_vm._v("便利店情况")]
            ),
            _c("p", { staticStyle: { "padding-left": "1rem" } }, [
              _vm._v("当天总销售额：" + _vm._s(_vm.dailyDiff.shopAmount))
            ])
          ]),
          _c("h3", { staticStyle: { margin: "1rem", "font-size": "1.4rem" } }, [
            _vm._v("差异比对")
          ]),
          _vm.showDailyDiffDialog && _vm.dailyDiff.chargeBackAmount < 0
            ? _c("el-alert", {
                attrs: {
                  title:
                    "当天充值数据中已对冲退卡/回款金额：" +
                    _vm.absNumber(_vm.dailyDiff.chargeBackAmount),
                  type: "success",
                  "show-icon": "",
                  closable: false
                }
              })
            : _vm._e(),
          _vm.showDailyDiffDialog && _vm.dailyDiff.lossAmount > 0
            ? _c("el-alert", {
                attrs: {
                  title:
                    "当天补卡应收金额：" +
                    _vm.absNumber(_vm.dailyDiff.lossAmount),
                  type: "error",
                  "show-icon": "",
                  closable: false
                }
              })
            : _vm._e(),
          _vm.showDailyDiffDialog && _vm.dailyDiff.preStationAmount > 0
            ? _c("el-alert", {
                attrs: {
                  title: "油品预收款数据",
                  description:
                    "油机金额：" +
                    _vm.dailyDiff.preStationSaleAmount +
                    "　升数：" +
                    _vm.dailyDiff.preStationOilMass +
                    "　优惠：" +
                    _vm.dailyDiff.preStationDiscount +
                    "　实收：" +
                    _vm.dailyDiff.preStationAmount,
                  type: "warning",
                  "show-icon": "",
                  closable: false
                }
              })
            : _vm._e(),
          _c(
            "h2",
            { staticStyle: { "padding-left": "1rem" } },
            [
              _vm._v("当班差异："),
              _c(
                "el-tag",
                {
                  staticStyle: { "font-size": "1.5rem" },
                  attrs: {
                    type:
                      _vm.amountFormat(
                        _vm.npMinus(
                          _vm.npPlus(
                            _vm.dailyDiff.cashAmount,
                            _vm.dailyDiff.posAmount,
                            _vm.dailyDiff.onlineAmount,
                            _vm.dailyDiff.svcAmount,
                            _vm.dailyDiff.walletAmount,
                            _vm.dailyDiff.creditAmount,
                            _vm.dailyDiff.accountAmount,
                            _vm.dailyDiff.platAmount,
                            _vm.dailyDiff.othersAmount,
                            _vm.dailyDiff.specialAmount,
                            _vm.dailyDiff.sellerDiscount,
                            _vm.dailyDiff.platDiscount
                          ),
                          _vm.npPlus(
                            _vm.dailyDiff.stationAmount,
                            _vm.dailyDiff.shopAmount,
                            _vm.dailyDiff.chargeAmount,
                            _vm.dailyDiff.lossAmount,
                            _vm.dailyDiff.loadometerAmount,
                            _vm.dailyDiff.creditAmount,
                            _vm.dailyDiff.accountAmount
                          )
                        ),
                        2
                      ) > 0
                        ? "success"
                        : "danger"
                  }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.amountFormat(
                        _vm.npMinus(
                          _vm.npPlus(
                            _vm.dailyDiff.cashAmount,
                            _vm.dailyDiff.posAmount,
                            _vm.dailyDiff.onlineAmount,
                            _vm.dailyDiff.svcAmount,
                            _vm.dailyDiff.walletAmount,
                            _vm.dailyDiff.creditAmount,
                            _vm.dailyDiff.accountAmount,
                            _vm.dailyDiff.platAmount,
                            _vm.dailyDiff.othersAmount,
                            _vm.dailyDiff.specialAmount,
                            _vm.dailyDiff.sellerDiscount,
                            _vm.dailyDiff.platDiscount
                          ),
                          _vm.npPlus(
                            _vm.dailyDiff.stationAmount,
                            _vm.dailyDiff.shopAmount,
                            _vm.dailyDiff.chargeAmount,
                            _vm.dailyDiff.lossAmount,
                            _vm.dailyDiff.loadometerAmount,
                            _vm.dailyDiff.creditAmount,
                            _vm.dailyDiff.accountAmount
                          )
                        ),
                        2
                      )
                    )
                  )
                ]
              )
            ],
            1
          ),
          _vm.userInfo.authorityId === "888" ||
          _vm.userInfo.authorityId === "9990" ||
          _vm.userInfo.authorityId === "30003" ||
          _vm.userInfo.authorityId === "9994"
            ? _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: [_vm.dailyDiff], border: "", stripe: "" }
                },
                [
                  _c(
                    "el-table-column",
                    { attrs: { label: "销售", align: "center" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "油机金额",
                          width: "110px",
                          prop: "stationAmount",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "便利店",
                          prop: "shopAmount",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "充值数据",
                          width: "110px",
                          prop: "chargeAmount",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "补卡",
                          prop: "lossAmount",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "地磅计费",
                          prop: "loadometerAmount",
                          align: "center"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-table-column",
                    { attrs: { label: "优惠", align: "center" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "平台优惠",
                          prop: "platDiscount",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "油站优惠",
                          prop: "sellerDiscount",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "特殊结算",
                          prop: "specialAmount",
                          align: "center"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-table-column",
                    { attrs: { label: "支付", align: "center" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "现金",
                          prop: "cashAmount",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "POS机",
                          width: "100px",
                          prop: "posAmount",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "在线支付",
                          width: "110px",
                          prop: "onlineAmount",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "储值卡",
                          width: "100px",
                          prop: "svcAmount",
                          align: "center"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.amountFormat(
                                          _vm.np3Minus(
                                            scope.row.svcAmount,
                                            scope.row.creditAmount,
                                            scope.row.accountAmount
                                          ),
                                          2
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1193001739
                        )
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "授权卡",
                          prop: "creditAmount",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "记账卡",
                          prop: "accountAmount",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "电子钱包",
                          prop: "walletAmount",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "平台",
                          width: "100px",
                          prop: "platAmount",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "其他",
                          prop: "othersAmount",
                          align: "center"
                        }
                      })
                    ],
                    1
                  ),
                  _c("el-table-column", {
                    attrs: {
                      label: "差异",
                      prop: "diffAmount",
                      align: "center"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.amountFormat(
                                      _vm.npMinus(
                                        _vm.npPlus(
                                          scope.row.cashAmount,
                                          scope.row.posAmount,
                                          scope.row.onlineAmount,
                                          scope.row.svcAmount,
                                          scope.row.walletAmount,
                                          scope.row.creditAmount,
                                          scope.row.accountAmount,
                                          scope.row.platAmount,
                                          scope.row.othersAmount,
                                          scope.row.specialAmount,
                                          scope.row.sellerDiscount,
                                          scope.row.platDiscount
                                        ),
                                        _vm.npPlus(
                                          scope.row.stationAmount,
                                          scope.row.shopAmount,
                                          scope.row.chargeAmount,
                                          scope.row.lossAmount,
                                          scope.row.loadometerAmount,
                                          scope.row.creditAmount,
                                          scope.row.accountAmount
                                        )
                                      ),
                                      2
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2826185115
                    )
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "1rem" }, attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-input", {
                    staticClass: "text-color",
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 2, maxRows: 4 },
                      placeholder: "请输入差异说明",
                      readonly: _vm.dailyDiff.dailyInfoStatus === 2
                    },
                    model: {
                      value: _vm.dailyDiff.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.dailyDiff, "remark", $$v)
                      },
                      expression: "dailyDiff.remark"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "medium",
                        disabled: _vm.dailyDiff.dailyInfoStatus === 2
                      },
                      on: {
                        click: function($event) {
                          return _vm.submitDailyRemark(
                            _vm.dailyDiff.dailyNo,
                            _vm.dailyDiff.stationId,
                            _vm.dailyDiff.dailyInfoStatus,
                            _vm.dailyDiff.remark
                          )
                        }
                      }
                    },
                    [_vm._v("提交")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "录入数据修正",
            top: "2rem",
            visible: _vm.showModifyDailyPayDataDialog,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.showModifyDailyPayDataDialog = $event
            }
          }
        },
        [
          _c(
            "el-form",
            { ref: "dataForm", attrs: { "label-position": "left" } },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.modifyDailyPayData.dailyPayWayData.filter(
                      function(data) {
                        return (
                          (data.payWay > 2000 &&
                            data.payWay < 3000 &&
                            data.payWay !== 2006) ||
                          data.payWay === 1001 ||
                          data.payWay === 1005 ||
                          data.payWay === 1015 ||
                          data.payWay === 1025 ||
                          data.payWay === 1045 ||
                          data.payWay === 1006 ||
                          data.payWay === 1008 ||
                          data.payWay === 1009
                        )
                      }
                    ),
                    border: "",
                    stripe: ""
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "收款方式",
                      prop: "payWayName",
                      align: "center"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "营业额",
                      prop: "checkPayablesAmount",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.payWay < 2000 && scope.row.payWay !== 1008
                              ? _c("div", [_vm._v(" -- ")])
                              : _c(
                                  "div",
                                  [
                                    _c("el-input-number", {
                                      staticStyle: { height: "47px" },
                                      attrs: {
                                        placeholder: "营业额",
                                        "controls-position": "right",
                                        precision: 2,
                                        min: 0,
                                        clearable: ""
                                      },
                                      model: {
                                        value: scope.row.checkPayablesAmount,
                                        callback: function($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "checkPayablesAmount",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "scope.row.checkPayablesAmount"
                                      }
                                    })
                                  ],
                                  1
                                )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "实收录入",
                      prop: "checkPaymentsAmount",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.payWay === 1001
                              ? _c(
                                  "div",
                                  [
                                    _vm._v(" A班： "),
                                    _c("el-input-number", {
                                      staticStyle: { height: "47px" },
                                      attrs: {
                                        placeholder: "A班实收",
                                        "controls-position": "right",
                                        precision: 2,
                                        min: 0,
                                        clearable: ""
                                      },
                                      model: {
                                        value: _vm.dailyCheckPaymentsAmount[0],
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.dailyCheckPaymentsAmount,
                                            0,
                                            $$v
                                          )
                                        },
                                        expression:
                                          "dailyCheckPaymentsAmount[0]"
                                      }
                                    }),
                                    _c("br"),
                                    _vm._v(" B班： "),
                                    _c("el-input-number", {
                                      staticStyle: { height: "47px" },
                                      attrs: {
                                        placeholder: "B班实收",
                                        "controls-position": "right",
                                        precision: 2,
                                        min: 0,
                                        clearable: ""
                                      },
                                      model: {
                                        value: _vm.dailyCheckPaymentsAmount[1],
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.dailyCheckPaymentsAmount,
                                            1,
                                            $$v
                                          )
                                        },
                                        expression:
                                          "dailyCheckPaymentsAmount[1]"
                                      }
                                    }),
                                    _c("br"),
                                    _vm._v(" C班： "),
                                    _c("el-input-number", {
                                      staticStyle: { height: "47px" },
                                      attrs: {
                                        placeholder: "C班实收",
                                        "controls-position": "right",
                                        precision: 2,
                                        min: 0,
                                        clearable: ""
                                      },
                                      model: {
                                        value: _vm.dailyCheckPaymentsAmount[2],
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.dailyCheckPaymentsAmount,
                                            2,
                                            $$v
                                          )
                                        },
                                        expression:
                                          "dailyCheckPaymentsAmount[2]"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  [
                                    _c("el-input-number", {
                                      staticStyle: { height: "47px" },
                                      attrs: {
                                        placeholder: "实收",
                                        "controls-position": "right",
                                        precision: 2,
                                        clearable: ""
                                      },
                                      model: {
                                        value: scope.row.checkPaymentsAmount,
                                        callback: function($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "checkPaymentsAmount",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "scope.row.checkPaymentsAmount"
                                      }
                                    })
                                  ],
                                  1
                                )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.showModifyDailyPayDataDialog = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { slot: "reference", type: "primary" },
                  on: { click: _vm.doModifyDailyPayData },
                  slot: "reference"
                },
                [_vm._v("确认")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "补入平台数据",
            top: "2rem",
            visible: _vm.showInsertDailyPayDataDialog,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.showInsertDailyPayDataDialog = $event
            }
          }
        },
        [
          _c(
            "el-form",
            { ref: "dataForm", attrs: { "label-position": "left" } },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.modifyDailyPayData.dailyPayWayData.filter(
                      function(data) {
                        return (
                          (data.payWay > 2000 &&
                            data.payWay < 3000 &&
                            data.payWay !== 2006) ||
                          data.payWay === 1001 ||
                          data.payWay === 1005 ||
                          data.payWay === 1015 ||
                          data.payWay === 1025 ||
                          data.payWay === 1045 ||
                          data.payWay === 1006 ||
                          data.payWay === 1008 ||
                          data.payWay === 1009
                        )
                      }
                    ),
                    border: "",
                    stripe: ""
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "收款方式",
                      prop: "payWay",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-select",
                              {
                                attrs: { size: "small", placeholder: "请选择" },
                                on: { change: _vm.selectChange },
                                model: {
                                  value: scope.row.payWay,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "payWay", $$v)
                                  },
                                  expression: "scope.row.payWay"
                                }
                              },
                              _vm._l(_vm.payChannels, function(item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: { label: item, value: parseInt(index) }
                                })
                              }),
                              1
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "营业额",
                      prop: "checkPayablesAmount",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.payWay < 2000 && scope.row.payWay !== 1008
                              ? _c("div", [_vm._v(" -- ")])
                              : _c(
                                  "div",
                                  [
                                    _c("el-input-number", {
                                      staticStyle: { height: "47px" },
                                      attrs: {
                                        placeholder: "营业额",
                                        "controls-position": "right",
                                        precision: 2,
                                        min: 0,
                                        clearable: ""
                                      },
                                      model: {
                                        value: scope.row.checkPayablesAmount,
                                        callback: function($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "checkPayablesAmount",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "scope.row.checkPayablesAmount"
                                      }
                                    })
                                  ],
                                  1
                                )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "实收录入",
                      prop: "checkPaymentsAmount",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("el-input-number", {
                              staticStyle: { height: "47px" },
                              attrs: {
                                placeholder: "实收",
                                "controls-position": "right",
                                precision: 2,
                                min: 0,
                                clearable: ""
                              },
                              model: {
                                value: scope.row.checkPaymentsAmount,
                                callback: function($$v) {
                                  _vm.$set(
                                    scope.row,
                                    "checkPaymentsAmount",
                                    $$v
                                  )
                                },
                                expression: "scope.row.checkPaymentsAmount"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.showInsertDailyPayDataDialog = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { slot: "reference", type: "primary" },
                  on: { click: _vm.doModifyDailyPayData },
                  slot: "reference"
                },
                [_vm._v("确认")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticStyle: { padding: "10px 20px" },
          attrs: {
            top: "2rem",
            width: "86%",
            title: _vm.excelReadDataTitle,
            visible: _vm.excelReadDataDialog
          },
          on: {
            "update:visible": function($event) {
              _vm.excelReadDataDialog = $event
            }
          }
        },
        [
          _c("h3", { staticStyle: { color: "red" } }, [
            _vm._v(
              "！！！请选择各平台" +
                _vm._s(_vm.dailyShift.reportDate) +
                "的对账单数据进行上传"
            )
          ]),
          _c("platform-data-excel-component", {
            attrs: {
              "daily-no": _vm.dailyCashierDataRow.dailyNo,
              "station-id": _vm.dailyCashierDataRow.stationId,
              "daily-date": parseInt(_vm.dailyCashierDataRow.reportDate),
              "on-success": _vm.handleSuccess,
              "before-upload": _vm.beforeUpload,
              "support-multiple": true,
              "filter-rules": _vm.filterRules
            }
          }),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%", "margin-top": "2px" },
              attrs: {
                data: _vm.excelReadGridData,
                "show-summary": "",
                border: "",
                "highlight-current-row": ""
              }
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", label: "状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.ID > 0
                          ? _c(
                              "el-popconfirm",
                              {
                                attrs: {
                                  title: "确定删除该条平台数据",
                                  "confirm-button-text": "继续",
                                  "cancel-button-text": "再看看"
                                },
                                on: {
                                  confirm: function($event) {
                                    return _vm.deleteOnePlatformData(scope.row)
                                  }
                                }
                              },
                              [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      slot: "reference",
                                      type: "success",
                                      size: "mini"
                                    },
                                    slot: "reference"
                                  },
                                  [_vm._v("已上传")]
                                )
                              ],
                              1
                            )
                          : _c(
                              "el-tag",
                              { attrs: { type: "warning", size: "mini" } },
                              [_vm._v("待上传")]
                            )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { align: "center", prop: "platName", label: "平台" }
              }),
              _c(
                "el-table-column",
                { attrs: { align: "center", label: "合计" } },
                [
                  _c("el-table-column", {
                    attrs: { align: "center", prop: "nums", label: "升数" }
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", prop: "total", label: "应收" }
                  }),
                  _vm.userInfo.authorityId === "888" ||
                  _vm.userInfo.authorityId === "9990" ||
                  _vm.userInfo.authorityId === "30003" ||
                  _vm.userInfo.authorityId === "9994"
                    ? _c("el-table-column", {
                        attrs: {
                          align: "center",
                          prop: "amount",
                          label: "实收"
                        }
                      })
                    : _vm._e(),
                  _vm.userInfo.authorityId === "888" ||
                  _vm.userInfo.authorityId === "9990" ||
                  _vm.userInfo.authorityId === "30003" ||
                  _vm.userInfo.authorityId === "9994"
                    ? _c("el-table-column", {
                        attrs: {
                          align: "center",
                          prop: "discount",
                          label: "优惠"
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-table-column",
                { attrs: { align: "center", label: "92#汽油" } },
                [
                  _c("el-table-column", {
                    attrs: { align: "center", prop: "nums92", label: "升数" }
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", prop: "total92", label: "应收" }
                  }),
                  _vm.userInfo.authorityId === "888" ||
                  _vm.userInfo.authorityId === "9990" ||
                  _vm.userInfo.authorityId === "30003" ||
                  _vm.userInfo.authorityId === "9994"
                    ? _c("el-table-column", {
                        attrs: {
                          align: "center",
                          prop: "amount92",
                          label: "实收"
                        }
                      })
                    : _vm._e(),
                  _vm.userInfo.authorityId === "888" ||
                  _vm.userInfo.authorityId === "9990" ||
                  _vm.userInfo.authorityId === "30003" ||
                  _vm.userInfo.authorityId === "9994"
                    ? _c("el-table-column", {
                        attrs: {
                          align: "center",
                          prop: "discount92",
                          label: "优惠"
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-table-column",
                { attrs: { align: "center", label: "95#汽油" } },
                [
                  _c("el-table-column", {
                    attrs: { align: "center", prop: "nums95", label: "升数" }
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", prop: "total95", label: "应收" }
                  }),
                  _vm.userInfo.authorityId === "888" ||
                  _vm.userInfo.authorityId === "9990" ||
                  _vm.userInfo.authorityId === "30003" ||
                  _vm.userInfo.authorityId === "9994"
                    ? _c("el-table-column", {
                        attrs: {
                          align: "center",
                          prop: "amount95",
                          label: "实收"
                        }
                      })
                    : _vm._e(),
                  _vm.userInfo.authorityId === "888" ||
                  _vm.userInfo.authorityId === "9990" ||
                  _vm.userInfo.authorityId === "30003" ||
                  _vm.userInfo.authorityId === "9994"
                    ? _c("el-table-column", {
                        attrs: {
                          align: "center",
                          prop: "discount95",
                          label: "优惠"
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-table-column",
                { attrs: { align: "center", label: "0#柴油" } },
                [
                  _c("el-table-column", {
                    attrs: { align: "center", prop: "nums0", label: "升数" }
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", prop: "total0", label: "应收" }
                  }),
                  _vm.userInfo.authorityId === "888" ||
                  _vm.userInfo.authorityId === "9990" ||
                  _vm.userInfo.authorityId === "30003" ||
                  _vm.userInfo.authorityId === "9994"
                    ? _c("el-table-column", {
                        attrs: {
                          align: "center",
                          prop: "amount0",
                          label: "实收"
                        }
                      })
                    : _vm._e(),
                  _vm.userInfo.authorityId === "888" ||
                  _vm.userInfo.authorityId === "9990" ||
                  _vm.userInfo.authorityId === "30003" ||
                  _vm.userInfo.authorityId === "9994"
                    ? _c("el-table-column", {
                        attrs: {
                          align: "center",
                          prop: "discount0",
                          label: "优惠"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.excelReadDataDialog = false
                      _vm.excelReadGridData = []
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-popconfirm",
                {
                  attrs: {
                    title: "确认无误点继续即可提交",
                    "confirm-button-text": "继续",
                    "cancel-button-text": "再看看"
                  },
                  on: { confirm: _vm.submitDailyPlatformData }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { slot: "reference", type: "primary" },
                      slot: "reference"
                    },
                    [_vm._v("确 定")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }